import { CmsMeta } from '../cmsMeta';
import './CmsBadge.css';

type CmsBadgeParams = {
	text: string;
	color?: 'default' | 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info';
};

export const CmsBadge = ({ color, text }: CmsBadgeParams): JSX.Element => {
	return (
		<div style={{ backgroundColor: color }} className="cms-badge">
			{text}
		</div>
	);
};

export const cmsMeta: CmsMeta = {
	description: 'A small coloured label, for marking something as new, discounted or certified.',
	example: ['CmsBadge', { text: 'Neu', color: 'primary' }],
};
